import React from 'react';
import { inject } from 'mobx-react';
import { GeneralStepTemplate } from 'themes/modules/product/wizard/pages';

@inject(i => ({
	productEditViewStore: i.rootStore.productEditViewStore,
}))
class GeneralStep extends React.Component {
	render() {
		return <GeneralStepTemplate {...this.props} />;
	}
}

export default GeneralStep;



// WEBPACK FOOTER //
// ./src/modules/product/wizard/pages/GeneralStep.jsx